import { Box, styled } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

const filterSizes = {
  sm: '220px',
  md: '400px',
};

const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'justify',
})<{ size?: Size; justify?: 'flex-start' | 'center' | 'flex-end' }>(
  ({ theme, size, justify }) => ({
    width: size ? (size === 'auto' ? 'auto' : filterSizes[size]) : '100%',
    flexGrow: size ? 0 : 1,
    flexShrink: size === 'auto' ? 0 : 1,
    flexBasis: size && size !== 'auto' ? filterSizes[size] : 'content',
    justifyContent: justify,
    display: 'flex',

    [theme.breakpoints.down('md')]: {
      flexBasis: 'auto',
      width: '100%',
    },
  }),
);

type Size = 'auto' | 'sm' | 'md';

type Props = {
  size?: Size;
  justify?: 'flex-start' | 'center' | 'flex-end';
};

const Filter: FC<PropsWithChildren<Props>> = ({
  children,
  size,
  justify = 'flex-start',
}) => {
  return (
    <Container size={size} justify={justify}>
      {children}
    </Container>
  );
};

export default Filter;
